import { Component, ViewEncapsulation } from '@angular/core';
import { DialogComponent } from '@next/core-lib/dialog';

import { CustomManureAbstractDialogData } from './abstract-dialog';

@Component({
  selector: 'agr-custom-dialog',
  templateUrl: './custom-dialog.component.html',
  styleUrls: ['./custom-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CustomDialogComponent<
  T extends CustomManureAbstractDialogData,
  R,
> extends DialogComponent<T, R> {
  constructor() {
    super();
  }
}
